// Wait for all RPA forms on the page to initialize
const rpaForms = document.querySelectorAll('.rpa-zip-form');

rpaForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
        e.preventDefault();

        const $thisForm = this;
        const zipInput = $thisForm.querySelector('.user_zipcode_input');

        const contactCards__container           = document.querySelector('.contactCards__container');

        const contactCards__image               = document.querySelector('.contactCards__image img');
        const contactCards__firstname_lastname  = document.querySelector('.contactCards__firstname_lastname');
        const contactCards__funfacts            = document.querySelector('.contactCards__funfacts');
        const contactCards__error               = document.querySelector('.contactCards__error');

        // Generated... Needed?
        const resultContainer = $thisForm.getAttribute('data-result-container-id') ? 
                                document.getElementById($thisForm.getAttribute('data-result-container-id')) : null;
        
        // Fallback to class if ID wasn't generated (single instance only)
        const fallbackContainer = $thisForm.querySelector('#readRPAs.contactCards');

        const resultSingleContainer = document.querySelector('.readRPAs.contactCards');
        let targetSingleContainer = resultSingleContainer ? 
        document.getElementById(resultSingleContainer) : null;
        
        let targetContainer = resultContainer || fallbackContainer;
        let rpa_user_zipcode = zipInput ? zipInput.value : false;

        // Basic Validation
        if (!rpa_user_zipcode) {
            if (contactCards__error) {
                contactCards__error.innerHTML = '<p>Please enter a ZIP Code</p>';
            }
            return;
        }

        const submitBtn = $thisForm.querySelector('button[type="submit"]');
        if(submitBtn) submitBtn.disabled = true;

        fetch(wprpa_ajax_obj.ajax_url, {
            method: 'POST',
            body: new URLSearchParams({
                action: 'readRPAs',
                nonce: wprpa_ajax_obj.nonce, // Nonce not matching? 
                rpa_user_zipcode: rpa_user_zipcode
            }),
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => {
            if (targetContainer) {
                contactCards__container.style.display = 'block'

                contactCards__image.setAttribute('src', data['data']['profileimage']);
                contactCards__image.setAttribute('srcset', '');
                contactCards__firstname_lastname.innerHTML    = data['data']['firstname'];
                contactCards__funfacts.innerHTML              = data['data']['funfacts'];

                // console.log('Data loaded:', data);
            } else if (resultSingleContainer) {
                resultSingleContainer.innerHTML = data['data']['htmlRPAs'];
            } else {
                console.error('No target container found for results.');
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
            if (contactCards__error) {
                contactCards__error.innerHTML = '<p>Error loading results. Please try again.</p>';
            }
        })
        .finally(() => {
            if(submitBtn) submitBtn.disabled = false;
        });
    });
})